import BookableServices from '@/components/home/bookable-services';
import Layout from './layout';
import LastReservations from '@/components/home/last-reservations';

export default function Home() {
  return <Layout main={<BookableServices />} side={<LastReservations />} />;
}
